var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ADD_PROJECTION from 'api/mutations/ADD_PROJECTION';
import ADD_PROJECTION_POINT from 'api/mutations/ADD_PROJECTION_POINT';
import ADD_PROJECTION_POINT_IMAGE from 'api/mutations/ADD_PROJECTION_POINT_IMAGE';
import UPDATE_PROJECTION_NAME from 'api/mutations/CHANGE_MODEL_PROJECTION_NAME';
import REMOVE_PROJECTION from 'api/mutations/REMOVE_PROJECTION';
import REMOVE_PROJECTION_POINT from 'api/mutations/REMOVE_PROJECTION_POINT';
import REMOVE_PROJECTION_POINT_IMAGE from 'api/mutations/REMOVE_PROJECTION_POINT_IMAGE';
import UPDATE_PROJECTION_POINT from 'api/mutations/UPDATE_PROJECTION_POINT';
import GET_MODEL_PROJECTION from 'api/queries/GET_MODEL_PROJECTION';
import GET_MODEL_PROJECTIONS from 'api/queries/GET_MODEL_PROJECTIONS';
import withAttachments from 'utils/graphql';
import client from '../api/environment';
const initialState = {
    items: [],
    item: null,
    zoom: 100,
    status: {
        fetch: 'idle',
        fetchItem: 'idle',
        add: 'idle',
        remove: 'idle',
        addPoint: 'idle',
        updatePoint: 'idle',
        removePoint: 'idle',
        addPointImage: 'idle',
        removePointImage: 'idle',
    },
    errors: {
        fetch: null,
        fetchItem: null,
        add: null,
        remove: null,
        addPoint: null,
        updatePoint: null,
        removePoint: null,
        addPointImage: null,
        removePointImage: null,
    },
    refetchFlags: {
        fetch: false,
        fetchItem: false,
        add: false,
        remove: false,
        addPoint: false,
        updatePoint: false,
        removePoint: false,
        addPointImage: false,
        removePointImage: false,
    },
};
export const fetchSpecificationProjections = createAsyncThunk('specificationProjections/fetchSpecificationProjections', ({ specificationId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const specifiactionProjectionsData = yield client.query({
            query: GET_MODEL_PROJECTIONS,
            variables: { modelSpecificationId: specificationId },
            fetchPolicy: 'network-only',
        });
        return specifiactionProjectionsData.data.node.projections.edges.map((item) => item.node);
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchSpecificationProjection = createAsyncThunk('specificationProjections/fetchSpecificationProjection', ({ specificationProjectionId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const specifiactionProjectionsData = yield client.query({
            query: GET_MODEL_PROJECTION,
            variables: { modelSpecificationProjectionId: specificationProjectionId },
            fetchPolicy: 'network-only',
        });
        return specifiactionProjectionsData.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addSpecificationProjection = createAsyncThunk('specificationProjections/addSpecificationProjection', ({ specificationId, file }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const wrappedMutation = withAttachments((options) => client.mutate(Object.assign({ mutation: ADD_PROJECTION }, options)));
        const response = yield wrappedMutation({
            variables: {
                modelSpecificationId: specificationId,
                file,
            },
        });
        return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.addModelSpecificationProjection) === null || _b === void 0 ? void 0 : _b.modelSpecificationProjection;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateSpecificationProjectionName = createAsyncThunk('specificationProjections/updateSpecificationProjectionName', ({ projectionId, name }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const updatedProjection = yield client.mutate({
            mutation: UPDATE_PROJECTION_NAME,
            variables: {
                modelSpecificationProjectionId: projectionId,
                name,
            },
        });
        return updatedProjection.data;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const removeSpecificationProjection = createAsyncThunk('specificationProjections/removeSpecificationProjection', ({ projectionId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const specifiactionProjectionData = yield client.mutate({
            mutation: REMOVE_PROJECTION,
            variables: { modelSpecificationProjectionId: projectionId },
        });
        return Object.assign({ projectionId }, specifiactionProjectionData.data);
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addProjectionPoint = createAsyncThunk('specificationProjections/addProjectionPoint', ({ modelSpecificationProjectionId, noteX, noteY, type, x, y, }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const projectioPointnData = yield client.mutate({
            mutation: ADD_PROJECTION_POINT,
            variables: {
                isVisible: true,
                modelSpecificationProjectionId,
                noteX,
                noteY,
                type,
                x,
                y,
            },
        });
        return Object.assign(Object.assign({}, projectioPointnData.data.addProjectionPoint.projectionPoint), { modelSpecificationProjectionId });
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateProjectionPoint = createAsyncThunk('specificationProjections/updateProjectionPoint', ({ projectionPointId, note, noteX, noteY, x, y, componentId, }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const projectioPointnData = yield client.mutate({
            mutation: UPDATE_PROJECTION_POINT,
            variables: {
                projectionPointId,
                note,
                noteX,
                noteY,
                x,
                y,
                componentId,
            },
        });
        return projectioPointnData.data.updateProjectionPoint.projectionPoint;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const removeProjectionPoint = createAsyncThunk('specificationProjections/removeProjectionPoint', ({ projectionPointId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const projectioPointnData = yield client.mutate({
            mutation: REMOVE_PROJECTION_POINT,
            variables: { projectionPointId },
        });
        return Object.assign({ projectionPointId }, projectioPointnData.data.removeProjectionPoint);
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addProjectionPointImage = createAsyncThunk('specificationProjections/addProjectionPointImage', ({ projectionPointId, file }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _c, _d;
    try {
        const wrappedMutation = withAttachments((options) => client.mutate(Object.assign({ mutation: ADD_PROJECTION_POINT_IMAGE }, options)));
        const response = yield wrappedMutation({
            variables: {
                projectionPointId,
                file,
            },
        });
        return (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.addProjectionPointPhoto) === null || _d === void 0 ? void 0 : _d.projectionPoint;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const removeProjectionPointImage = createAsyncThunk('specificationProjections/removeProjectionPointImage', ({ projectionPointId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const projectioPointnData = yield client.mutate({
            mutation: REMOVE_PROJECTION_POINT_IMAGE,
            variables: { projectionPointId },
        });
        return Object.assign({ projectionPointId }, projectioPointnData.data.removeProjectionPointPhoto.projectionPoint);
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const specificationProjectionsSlice = createSlice({
    name: 'specificationProjections',
    initialState,
    reducers: {
        resetSpecificationProjectionsState(state) {
            state.items = [];
            state.item = null;
            state.zoom = 100;
            state.status.fetch = 'idle';
            state.errors.fetch = null;
            state.refetchFlags.fetch = false;
        },
        setSpecificationProjectionsRefetchFlag(state, action) {
            state.refetchFlags.fetch = action.payload;
        },
        setZoom(state, action) {
            state.zoom = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetchSpecificationProjections
            .addCase(fetchSpecificationProjections.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchSpecificationProjections.fulfilled, (state, action) => {
            state.status.fetch = 'succeeded';
            state.items = action.payload;
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchSpecificationProjections.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch =
                action.payload || 'Failed to fetch specification projections';
        })
            // fetchSpecificationProjection
            .addCase(fetchSpecificationProjection.pending, (state) => {
            state.status.fetchItem = 'loading';
        })
            .addCase(fetchSpecificationProjection.fulfilled, (state, action) => {
            state.status.fetchItem = 'succeeded';
            state.item = action.payload;
            state.refetchFlags.fetchItem = false;
        })
            .addCase(fetchSpecificationProjection.rejected, (state, action) => {
            state.status.fetchItem = 'failed';
            state.errors.fetchItem =
                action.payload || 'Failed to fetch specification projections';
        })
            .addCase(addSpecificationProjection.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(addSpecificationProjection.fulfilled, (state, action) => {
            state.status.add = 'succeeded';
            state.item = action.payload;
            state.items.push(action.payload);
        })
            .addCase(addSpecificationProjection.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add =
                action.payload || 'Failed to add new specification projection';
        })
            .addCase(updateSpecificationProjectionName.pending, (state) => {
            state.status.update = 'loading';
        })
            .addCase(updateSpecificationProjectionName.fulfilled, (state, action) => {
            state.status.update = 'succeeded';
            const index = state.items.findIndex((projection) => projection.id === action.meta.arg.projectionId);
            if (index !== -1) {
                state.items[index] = Object.assign(Object.assign({}, state.items[index]), { name: action.meta.arg.name });
            }
        })
            .addCase(updateSpecificationProjectionName.rejected, (state, action) => {
            state.status.update = 'failed';
            state.errors.add =
                action.payload || 'Failed to add new specification projection';
        })
            .addCase(removeSpecificationProjection.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(removeSpecificationProjection.fulfilled, (state, action) => {
            state.status.remove = 'succeeded';
            const index = state.items.findIndex((projection) => projection.id === action.payload.projectionId);
            if (index !== -1) {
                state.items.splice(index, 1);
            }
        })
            .addCase(removeSpecificationProjection.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove =
                action.payload || 'Failed to remove specification projection';
        })
            .addCase(addProjectionPoint.pending, (state) => {
            state.status.addPoint = 'loading';
        })
            .addCase(addProjectionPoint.fulfilled, (state, action) => {
            state.status.addPoint = 'succeeded';
            state.item.points.edges.push({ node: action.payload });
        })
            .addCase(addProjectionPoint.rejected, (state, action) => {
            state.status.addPoint = 'failed';
            state.errors.addPoint =
                action.payload || 'Failed to remove specification projection';
        })
            .addCase(updateProjectionPoint.pending, (state, action) => {
            var _a;
            state.status.updatePoint = 'loading';
            const index = (_a = state.item) === null || _a === void 0 ? void 0 : _a.points.edges.findIndex((point) => point.node.id === action.meta.arg.projectionPointId);
            if (index !== -1) {
                state.item.points.edges[index].node = Object.assign(Object.assign({}, state.item.points.edges[index].node), action.meta.arg);
            }
        })
            .addCase(updateProjectionPoint.fulfilled, (state, action) => {
            var _a, _b;
            state.status.updatePoint = 'succeeded';
            const index = (_b = (_a = state.item) === null || _a === void 0 ? void 0 : _a.points) === null || _b === void 0 ? void 0 : _b.edges.findIndex((point) => point.node.id === action.payload.id);
            if (index !== -1) {
                state.item.points.edges[index].node = Object.assign(Object.assign({}, state.item.points.edges[index].node), action.payload);
            }
        })
            .addCase(updateProjectionPoint.rejected, (state, action) => {
            state.status.updatePoint = 'failed';
            state.errors.updatePoint =
                action.payload || 'Failed to update specification projection';
        })
            .addCase(removeProjectionPoint.pending, (state) => {
            state.status.removePoint = 'loading';
        })
            .addCase(removeProjectionPoint.fulfilled, (state, action) => {
            state.status.removePoint = 'succeeded';
            const index = state.item.points.edges.findIndex((point) => point.node.id === action.payload.projectionPointId);
            if (index !== -1) {
                state.item.points.edges.splice(index, 1);
            }
        })
            .addCase(removeProjectionPoint.rejected, (state, action) => {
            state.status.removePoint = 'failed';
            state.errors.removePoint =
                action.payload || 'Failed to remove specification projection';
        })
            .addCase(addProjectionPointImage.pending, (state) => {
            state.status.addPointImage = 'loading';
        })
            .addCase(addProjectionPointImage.fulfilled, (state, action) => {
            state.status.addPointImage = 'succeeded';
            const { id, photo } = action.payload; // image to string (URL lub ID)
            const index = state.item.points.edges.findIndex((point) => point.node.id === id);
            if (index !== -1) {
                state.item.points.edges[index].node.photo = photo;
            }
        })
            .addCase(addProjectionPointImage.rejected, (state, action) => {
            state.status.addPointImage = 'failed';
            state.errors.addPointImage =
                action.payload || 'Failed to remove specification projection';
        })
            .addCase(removeProjectionPointImage.pending, (state) => {
            state.status.removePointImage = 'loading';
        })
            .addCase(removeProjectionPointImage.fulfilled, (state, action) => {
            state.status.removePointImage = 'succeeded';
            const { id } = action.payload;
            const index = state.item.points.edges.findIndex((point) => point.node.id === id);
            if (index !== -1) {
                state.item.points.edges[index].node.photo = null;
            }
        })
            .addCase(removeProjectionPointImage.rejected, (state, action) => {
            state.status.removePointImage = 'failed';
            state.errors.removePointImage =
                action.payload || 'Failed to remove specification projection';
        });
    },
});
export const { resetSpecificationProjectionsState, setSpecificationProjectionsRefetchFlag, setZoom, } = specificationProjectionsSlice.actions;
export const selectSpecificationProjectionsStatus = (state) => state.specificationProjections.status;
export const selectSpecificationProjectionsErrors = (state) => state.specificationProjections.errors;
export const selectSpecificationProjectionsRefetchFlags = (state) => state.specificationProjections.refetchFlags;
export const selectSpecificationProjections = (state) => state.specificationProjections.items;
export const selectSpecificationProjection = (state) => state.specificationProjections.item;
export const selectSpecificationProjectionsZoom = (state) => state.specificationProjections.zoom;
export default specificationProjectionsSlice.reducer;
